import CalendarSurfaceItemBase from './itemTemplates/CalendarSurfaceItem.base';
import React from 'react';
import { BaseComponent } from 'office-ui-fabric-react/lib/Utilities';
import { CalendarSurfaceItemProps } from './itemTemplates/CalendarSurfaceItem.types';
import { getStyles } from './itemTemplates/CalendarSurfaceItem.styles';

let surfaceItemStyles = require('./CalendarSurfaceItem.scss');

export default class CalendarSurfaceBlankItem extends BaseComponent<CalendarSurfaceItemProps, {}> {
    public render() {
        return (
            <CalendarSurfaceItemBase
                {...this.props}
                onRender={this.renderContent}
                styles={getStyles}
            />
        );
    }

    private renderContent = () => {
        const { children } = this.props;
        return children ? <> {children} </> : <div className={surfaceItemStyles.itemContent} />;
    };
}
